import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type ListSignoffSignersOptions = CommonRequestOptions & {
   limit?: number;
   offset?: number;
   searchTerm?: string;
};

export type Signer = {
   userid: number;
   username: string;
   email_or_unique_username?: string;
   profileUrl?: string;
   avatarUrl?: string;
};

export type ListSignoffSignersResponse = {
   signers: Signer[];
   totalEntries: number;
};

export async function listSignoffSigners(
   stageAssessmentId: number,
   { limit, offset, searchTerm, ...common }: ListSignoffSignersOptions = {}
): Promise<ListSignoffSignersResponse> {
   return await makeRequest('post', `courses/stage-sign-offs/${stageAssessmentId}/signers`, {
      ...common,
      body: {
         limit,
         offset,
         search_term: searchTerm,
      },
   });
}
